import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lieferant_details = _resolveComponent("lieferant-details")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_benutzer_liste = _resolveComponent("benutzer-liste")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { sm: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_lieferant_details, {
                    "lieferant-daten": _ctx.lieferantDetailData,
                    onSuccess: _ctx.loadLieferantDetails
                  }, null, 8, ["lieferant-daten", "onSuccess"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.isLieferantMain)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                sm: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_benutzer_liste, { "benutzer-list": _ctx.lieferantBenutzerData }, null, 8, ["benutzer-list"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}